const ColorUtil = require("./ColorUtil");
const Color = require("color");

//Draws a square for a hundreds chart with the colors of the multiples and the stripes corresponding to each multiple
const drawMultiplePattern = function(ctx, rect, multiples, noAlpha) {
	if (!Array.isArray(multiples)) {
		multiples = [multiples];
	}
	ctx.save();
	const r = rect;
	//Draing the color for each multiple
	//Change .getMultipleColors( to getMultipleColorsHundreds(
	let i;
	if (multiples.length) {
		let color = Color(ColorUtil.getMultipleColorsHundreds(multiples[0]));
		for (i = 1; i < multiples.length; i++) {
			const multipleColor = Color(
				ColorUtil.getMultipleColorsHundreds(multiples[i])
			);
			color = color.mix(multipleColor, 1 / (i + 1));
		}
		if (!noAlpha) {
			ctx.globalAlpha = Math.min(0.3 + 0.35 * (multiples.length - 1), 1);
		}
		ctx
			.bp()
			.rect(r[0], r[1], r[2], r[3])
			.fill(color.string());
	}
	ctx.restore();
};

module.exports = {
	drawMultiplePattern,
};
